export const CHECK_USER_KEYCLOAK_EXISTS = 'CHECK_USER_KEYCLOAK_EXISTS';
export const LOAD_USER_ROLES = 'LOAD_USER_ROLES';
export const REDIRECT_TO_USER_FORM = 'REDIRECT_TO_USER_FORM';

export const GET_USER_ROLES = 'GET_USER_ROLES';
export const GET_USER_ROLES_START = 'GET_USER_ROLES_START';
export const GET_USER_ROLES_SUCCESS = 'GET_USER_ROLES_SUCCESS';
